import { render, staticRenderFns } from "./NSRResultsGrid.vue?vue&type=template&id=096df604"
import script from "./NSRResultsGrid.vue?vue&type=script&lang=js"
export * from "./NSRResultsGrid.vue?vue&type=script&lang=js"
import style0 from "./NSRResultsGrid.vue?vue&type=style&index=0&id=096df604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports